export class FeatureFlagProvider {
  constructor(sdkKey, environment) {
    this.sdkKey = sdkKey;
    this.environment = environment;
  }

  initialize(user = new UserContext()) {
    throw new Error("Method 'initialize()' must be implemented.");
  }

  getFeatureFlagValue(key, defaultValue) {
    throw new Error("Method 'getFeatureFlagValue()' must be implemented.");
  }
}

export class UserContext {
  constructor(userID, email) {
    this.userID = userID;
    this.email = email;
  }
}
